import { ConfirmationModal } from 'views/components';
import { ExpandButton } from 'mol-ui';
import PropTypes from 'prop-types';
import { Col, Row } from './styled';
import React, { useState } from 'react';

const ConfirmFooter = ({
    cancelModalText,
    cancelText,
    confirmModal,
    confirmModalText,
    confirmText,
    disabled,
    onBeforeConfirm,
    onCancel,
    onConfirm
}) => {

    const { t } = useTranslation();
    const [modal, setModal] = useState('');

    const handleAccept = () => {
        setModal('');
        modal === 'confirm' ? onConfirm() : onCancel();
    };

    const handleConfirm = () => {
        if (confirmModal) {
            if (!onBeforeConfirm || onBeforeConfirm()) {
                setModal('confirm');
            }
        } else {
            onConfirm();
        }
    };
    
    return (
        <Row>
            <ConfirmationModal
                actionHandler={ value => value === 'cancel' ? setModal('') : handleAccept() }
                active={ !!modal }
                title={ modal === 'cancel' ? (cancelModalText || t('¿Desea cancelar?')) : (confirmModalText || t('Confirmar')) }
            />
            <Col>
                {
                    onCancel &&
                    <ExpandButton
                        danger
                        caption={ cancelText || t('Cancelar') }
                        disabled={ disabled }
                        size={ 120 }
                        onClick={ () => setModal('cancel') }
                    />
                }
                {
                    onConfirm &&
                    <ExpandButton
                        caption={ confirmText || t('Confirmar') }
                        disabled={ disabled }
                        size={ 120 }
                        onClick={ handleConfirm }
                    />
                }
            </Col>
        </Row>
    );
};

ConfirmFooter.propTypes = {
    cancelModalText: PropTypes.string,
    cancelText: PropTypes.string,
    confirmModal: PropTypes.bool,
    confirmModalText: PropTypes.string,
    confirmText: PropTypes.string,
    disabled: PropTypes.bool,
    onBeforeConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
};

export default ConfirmFooter;
